var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrophoneOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5v5M8 11.5a4 4 0 004 4M8.44 2.675A4 4 0 0116 4.5v6.11",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5v3c0 1.11-.378 1.593-.5 2.11M5 8.5v3a7 7 0 007 7c.643 0 1.908-.228 2.5-.39M1 .11l21 21",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTIgMTguNVYyMy41IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTggMTEuNUM4IDEzLjcwOTEgOS43OTA4NiAxNS41IDEyIDE1LjVNOC40Mzk4IDIuNjc0NzFDOS4xMDMxNiAxLjM4MzQyIDEwLjQ0ODQgMC41IDEyIDAuNUMxNC4yMDkxIDAuNSAxNiAyLjI5MDg2IDE2IDQuNVYxMC42MDkzIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5IDguNVYxMS41QzE5IDEyLjYwOTMgMTguNjIxNiAxMy4wOTI2IDE4LjUgMTMuNjA5M001IDguNVYxMS41QzUgMTUuMzY2IDguMTM0MDEgMTguNSAxMiAxOC41QzEyLjY0MzMgMTguNSAxMy45MDgzIDE4LjI3MTggMTQuNSAxOC4xMDkzIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEgMC4xMDkzMTRMMjIgMjEuMTA5MyIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgMicrophoneOff as ReactComponent };